<template>
  <b-card>
    <b-list-group>
      <donation-group />
      <bank-account />
      <safe-account />
      <donate-date />
      <notes-text />
      <amount />
    </b-list-group>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup,
} from 'bootstrap-vue'
import DonationGroup from '@/views/Admin/Account_activities/Expenses/PreviewCard/DonationGroup.vue'
import BankAccount from '@/views/Admin/Account_activities/Expenses/PreviewCard/BankAccount.vue'
import SafeAccount from '@/views/Admin/Account_activities/Expenses/PreviewCard/SafeAccount.vue'
import DonateDate from '@/views/Admin/Account_activities/Expenses/PreviewCard/DonateDate.vue'
import NotesText from '@/views/Admin/Account_activities/Expenses/PreviewCard/Notes.vue'
import Amount from '@/views/Admin/Account_activities/Expenses/PreviewCard/Amount.vue'

export default {
  name: 'PreviewCard',
  components: {
    BCard,
    BListGroup,
    DonationGroup,
    BankAccount,
    SafeAccount,
    DonateDate,
    NotesText,
    Amount,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
